export default __webpack_public_path__ + "static/media/(19).032e81ee.jpg";